import {
  ProductDetailsModal,
  ProductCardModal,
} from "../../interfaces/ProductObject";
import { convertProductDetailsToProductCard } from "../converters/backendToUi/productConvertor";

class ProductCardHelper {
  /**
   * Converts a ProductDetails object into a ProductCard object using the converter method.
   * @param productDetails - The ProductDetails object to convert.
   * @returns A ProductCard object.
   */
  public static retrieveProductCard(
    productDetails: ProductDetailsModal,
  ): ProductCardModal {
    return convertProductDetailsToProductCard(productDetails);
  }
}

export default ProductCardHelper;
